import React from 'react'
import MarkErrorItemPage from './MarkErrorItemPage'
import '../styles/index.scss'

const MarkErrorItemContainer = () => {
    return (
        <div className='MarkErrorItemContainer'>
            <MarkErrorItemPage />
        </div>
    )
}

export default MarkErrorItemContainer